import WaybillTemplateDTO from "@/dto/template/WaybillTemplateDTO";
import { Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import OrderTag from "@/enum/OrderTag";
import MultiPlatformStorageManager from "../MultiPlatformStorageManager";
import { useOrderManagementStore } from "@/scenes/OrderManagementForAllShop/stores/OrderManagementForAllShopStore";
import EwaybillQuantityInfo from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/EwaybillQuantityInfo";

interface AliTemplateSelectExtraProps {
    template: WaybillTemplateDTO;
    orderTag: OrderTag;
}

const AliOutOrderTemplateSelectExtra: React.FC<AliTemplateSelectExtraProps> = function (props) {
    const { template, orderTag } = props;
    const [defaultTemplateId, setDefaultTemplateId] = useState<number>();

    const globalStore = useGlobalStore();

    const templates = globalStore.waybillPrintStore.waybillTemplates;

    const orderManagementStore = useOrderManagementStore();

    /** @todo shop从外面传入或者这里另外处理快速查单的上下文 */
    const shopId = orderManagementStore?.shopId || undefined;

    useEffect(() => {
        const defaultTemplateId = MultiPlatformStorageManager.getAliTagDefaultWaybillTemplate(shopId, orderTag);

        // 快递单模板里能找到设置的默认模板才显示清除
        if (templates && templates.length && defaultTemplateId) {
            const template = templates.find((it) => it.id === defaultTemplateId);

            if (template) {
                setDefaultTemplateId(defaultTemplateId);
            }
        }
    }, []);

    if (!template) {
        if (orderTag === OrderTag.ALI_OUT_ORDER_WEIXIN) {
            return (
                <div>
                    需使用微信小店供货商店铺开通电子面单，
                    <a
                        href="https://qw15p3s8hv.feishu.cn/wiki/JYmjwv6oHil906kKG6icbae6nKg"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        查看教程
                    </a>
                </div>
            );
        }

        return null;
    }

    function handleSetDefaultWaybillTemplate(e) {
        e.preventDefault();

        const { id, name } = template;

        MultiPlatformStorageManager.setAliTagDefaultWaybillTemplate(shopId, orderTag, id);

        Modal.success({
            title: ` 设置成功，默认快递单模板为：${name}`,
        });

        setDefaultTemplateId(id);
    }

    function handleClearDefaultWaybillTemplate(e) {
        e.preventDefault();

        MultiPlatformStorageManager.setAliTagDefaultWaybillTemplate(shopId, orderTag, null);

        Modal.success({
            title: "清除默认模板成功！",
        });

        setDefaultTemplateId(null);
    }

    function buildClearDefaultTemplateTypeButton() {
        if (!defaultTemplateId || !templates) return null;

        const template = templates.find((it) => it.id === defaultTemplateId);

        if (template) {
            return (
                <Tooltip title={`当前默认模板：${template.name}，点击可清除默认模板`}>
                    <a href="#" onClick={handleClearDefaultWaybillTemplate} className="mr10">
                        （清除）
                    </a>
                </Tooltip>
            );
        }

        return null;
    }

    return (
        <div>
            <a href="#" onClick={handleSetDefaultWaybillTemplate} className="mr10">
                设为默认模板
            </a>

            <EwaybillQuantityInfo template={template} />

            {buildClearDefaultTemplateTypeButton()}
        </div>
    );
};

export default observer(AliOutOrderTemplateSelectExtra);
